module.exports = __webpack_public_path__ + "static/media/thought.9e2c5534.png";